import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import CommonCJAMiddleware from 'yoda-site-components/lib/middlewares/CommonCJAMiddleware';
import CheckoutMiddleware from 'yoda-checkout-components/lib/middlewares/CheckoutAnalyticsMiddleware';
import CartMiddleware from 'yoda-checkout-components/lib/middlewares/CartAnalyticsMiddleware';

const rootMiddleware = [CommonMiddleware, CommonCJAMiddleware, CheckoutMiddleware, CartMiddleware];

export default rootMiddleware;
